import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { AuthDetailsService } from '../../../common/auth-details/auth-details.service';

@Injectable()

export class EditDoctorService extends iBisSecureEditService {

    public data: CustomStore;
    public allData: CustomStore;
    public partyData: CustomStore;

    constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService, private ad: AuthDetailsService) {
        super(auth, entity, config, lg);
        this.title = 'DOCTOR';
        this.validation = 'doctorValidation';

        this.ad.onDataChanged.subscribe(_ => {
            this.load();
        })
    }

    protected load(): void {
        this.ad.partyUserDataLoadedSubject.subscribe(_ => {
            this.getPartyData();
            this.getUsers();
        })
    }

    getById(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.entity.getById('Doctor', id).then((res: any) => {
                if (res) {
                    resolve(res);
                } else {
                    reject();
                }
            }, error => this.lg.showError(error));
        });
    }

    onRemove(id: string): Promise<void> {
        return this.entity.remove('Doctor', id);
    }

    onSaveEv(): Promise<any> {
        this.model.firstName = this.model.firstName.trim();
        this.model.lastName = this.model.lastName.trim();
        return this.entity.save('Doctor', this.model.id, this.model);
    }

    reset(): void {
        this.model = this.createDefault();
    }

    createDefault() {
        return { isActiv: true };
    }

    private getData() {
        const doctorRoleIdQ = new EntityQuery('UserLoginRole').eq('name', 'doctor').link('groupId', 'id', new EntityQuery('EnumValue')
            //TODO: uncomment it when is added on db .eq('name', 'MDS')
            .linkEq('typeId', 'id', 'EnumType', 'name', 'ROLE_GROUP'));
        this.entity.single(doctorRoleIdQ, this.config.saasServer).then((doctorRole: any) => {
            const q = new EntityQuery('PartyUser').eq('partyId', this.ad.authDetails.party.id);
            this.entity.load(q).then((clinicDoctors: any[]) => {
                this.allData = this.entity.store(new EntityQuery('UserLogin').in('id', clinicDoctors.map(cd => cd.userId)), false, 'id', this.config.saasServer);
            });
        });
    }

    private getUsers() {
        const q = new EntityQuery('UserLogin').eq('isActiv', true);
        q.link('id', 'userId', new EntityQuery('ApplicationRole').eq('appId', this.auth.companyId));
        q.distinct = true;
        this.allData = this.entity.store(q, false, 'id', this.config.saasServer)
    }

    private getPartyData() {
        const doctorRoleIdQ = new EntityQuery('UserLoginRole').eq('name', 'doctor').link('groupId', 'id', new EntityQuery('EnumValue')
            //TODO: uncomment it when is added on db .eq('name', 'MDS')
            .linkEq('typeId', 'id', 'EnumType', 'name', 'ROLE_GROUP'));
        this.entity.single(doctorRoleIdQ, this.config.saasServer).then((doctorRole: any) => {
            const q = new EntityQuery('PartyUser').eq('roleId', doctorRole.id).eq('partyId', this.ad.authDetails.party.id);
            this.entity.load(q).then((clinicDoctors: any[]) => {
                this.data = this.entity.store(new EntityQuery('UserLogin').in('id', clinicDoctors.map(cd => cd.userId)), false, 'id', this.config.saasServer);
            });
        });
    }
}
